import { Typography } from 'antd'
import Filters from '../MapMenu/Filters'
import { useTranslation } from 'react-i18next';

interface IProps {
    isArrivalMonthFilterEnabled?: boolean,
    isAgeFilterEnabled?: boolean,
    hideTooltips?: boolean,
    getDeclarationsSinceMonths?: number,
    singleSidedDeclarationSlider?: boolean
}

export default function FiltersTab(props: IProps) {
    const { t } = useTranslation("sidePanelTabs");

    return (
        <>
            <Typography.Title level={4}>{t("mkiSuodattimet")}</Typography.Title>
            <Filters {...props} />
        </>
    )
}